import { jsx as _jsx } from "react/jsx-runtime";
import { BLOCKS, INLINES } from '@contentful/rich-text-types';
import parse from '@hellodarwin/core/lib/features/helpers/parse';
import { useMemo } from 'react';
import ContentfulLink from '../components/common/Link/ContentfulLink';
import { renderRichText } from './richText';
const defaultTextOptions = {
    renderNode: {
        [BLOCKS.PARAGRAPH]: (node, children) => {
            return children;
        },
        [INLINES.HYPERLINK]: (node, children) => {
            const { uri: url } = node.data;
            return (_jsx("div", { style: { marginTop: 16 }, children: _jsx(ContentfulLink, { url: url, children: children }) }));
        },
    },
};
const useFormatBody = ({ body, bodyLong, bodyLong2, textOptions, }) => {
    return useMemo(() => {
        if (!!(bodyLong2 === null || bodyLong2 === void 0 ? void 0 : bodyLong2.length)) {
            return parse(bodyLong2);
        }
        else if (!!bodyLong) {
            return renderRichText(bodyLong, textOptions !== null && textOptions !== void 0 ? textOptions : defaultTextOptions);
        }
        else if (!!(body === null || body === void 0 ? void 0 : body.length)) {
            return parse(body);
        }
        else {
            return undefined;
        }
    }, [body, bodyLong, bodyLong2, textOptions]);
};
export default useFormatBody;
